/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';

import appReducers from './containers/App/appReducers';
import sessionModule from './containers/App/session';

const { routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    // other options if needed
});

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function rootReducer(state, action, injectedReducers = {}) {
    let newState;
    switch (action.type) {
        case sessionModule.constants.RESET_APP:
            newState = undefined;
            break;
        default:
            newState = state;
            break;
    }

    return combineReducers({
        ...appReducers,
        // Injected reducers
        ...injectedReducers,
        router: routerReducer,
    })(newState, action);
}
